import { render, staticRenderFns } from "./ShipToAddrSectionView.vue?vue&type=template&id=f53e31c4&scoped=true&"
import script from "./ShipToAddrSectionView.vue?vue&type=script&lang=js&"
export * from "./ShipToAddrSectionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53e31c4",
  null
  
)

export default component.exports